import styled from 'styled-components'

export const Textarea = styled.textarea`
  height: 40px;
  border: 1px solid #d2d2d2;
  border-radius: 2px;
  width: calc(100% - 16px);
  font-size: 1.2rem;
  padding: 4px 8px;
`;
